import React, { useState } from "react";
import logo from "../../../../images/leave-primary.png";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const Navbar = () => {
  const [nav, setnav] = useState(false);
  const changeBackground = () => {
    if (window.scrollY >= 50) {
      setnav(true);
    } else {
      setnav(false);
    }
  };
  window.addEventListener("scroll", changeBackground);
  return (
    <nav className={nav ? "navi-nav active" : "navi-nav"}>
      <a href="." className="logo">
        <img src={logo} alt="" />
      </a>
      <ul className="menu">
        <li>
          <Link to="/Login" style={{ textDecoration: "none" }}>
            <button className="btn-login p-0">LOGIN</button>
          </Link>
        </li>
        <li>
          <Link to="/registration" style={{ textDecoration: "none" }}>
            <button className="btn-sign p-0">Register</button>
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
